import { useEffect, useState } from "react";
import SourceWiz from "../routes/SourceWiz/index";
import Onboarding from "../routes/Onboarding/index";
import API_KEY from "../api";
import { useGlobal } from "../store/index";
import Loading from "./Loading";
import { gaConfig } from "../analytics/analytics";
import ability from "../casl/ability";
import { AbilityBuilder } from "@casl/ability";

const userData = localStorage.getItem("user");
const user = JSON.parse(userData);

export default function MainApp() {
  // const [isOnboarding, setIsOnboarding] = useState(true);
  const [globalState, globalActions] = useGlobal();
  const [spinning, setSpinning] = useState(false);

  const { isOnboarding, permissions, loading } = globalState;
  // const [userData, setUserData] = useState(null);

  const defineRulesFor = (auth) => {
    const permissions = auth?.permissions;
    const { can, rules } = new AbilityBuilder();

    // This logic depends on how the
    // server sends you the permissions array
    if (permissions) {
      permissions.forEach((p) => {
        if (p.toggleValue) {
          can(p?.slug, p?.permissionType);
        }
        //
      });
    }
    //  window.location.reload();
    return rules;
  };

  useEffect(() => {
    if (permissions) {
      ability.update(defineRulesFor(permissions));
    }
  }, [permissions]);

  // useEffect(() => {
  //   const userId = localStorage.getItem("userId");

  //  if (userId) {
  //   globalActions.permissions.getPermissions(JSON.parse(userId));
  //   gaConfig({
  //     // s_user_id is alias of user_id
  //     s_user_id: userId,
  //     user_id: userId,
  //   });
  //  }
  // }, []);

  useEffect(() => {
    const userEmail = localStorage.getItem("email");
    // const user = localStorage.getItem("user");
    setSpinning(true);
    API_KEY.URL.get(API_KEY.path.users, {
      params: {
        "filter[email][_eq]": JSON.parse(userEmail),
        // access_token: JSON.parse(user)?.access_token,
      },
    })
      .then((res) => {
        const userId = res.data?.data[0]?.id;
        const is_admin = res.data?.data[0]?.is_admin;

        localStorage.setItem("userId", JSON.stringify(userId));
        localStorage.setItem("isAdmin", is_admin);
        //get permissions for CASL to work
        globalActions.permissions.getPermissions(userId);
        API_KEY.URL.get(API_KEY.path.manufacturer, {
          params: {
            // access_token: JSON.parse(user)?.access_token,
          },
        })
          .then((res) => {
            if (res.data.data.length > 0) {
              localStorage.setItem(
                "pref",
                JSON.stringify(res.data?.data?.[0]?.recommendation_preferences)
              );
              if (res.data.data[0].status === "published") {
                globalActions.authActions.setOnboarding(false);
              }
            } else if (res.data.data.length === 0) {
              globalActions.authActions.setOnboarding(true);
            }
            setSpinning(false);
          })
          .catch((err) => {
            console.log(err);
            setSpinning(false);
          });
      })
      .catch((err) => {
        setSpinning(false);
        if (err?.response?.status > 399) {
          localStorage.clear();
          window.location.reload();
        }
      });
  }, [globalActions]);

  if (spinning) {
    return <Loading />;
  }

  return permissions ? <SourceWiz /> : <Loading />;

  // isOnboarding ? <Onboarding /> : <SourceWiz />
}
